var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', _vm._b({
    class: [_vm.color == 'grey' ? 'border-color border-grey-lighten-3' : ''],
    attrs: {
      "variant": "outlined",
      "rounded": "",
      "color": _vm.color
    },
    scopedSlots: _vm._u([_vm._l(_vm.$slots, function (_, slotName) {
      return {
        key: slotName,
        fn: function () {
          return [_vm._t(slotName)];
        },
        proxy: true
      };
    })], null, true)
  }, 'v-btn', _vm.$attrs, false));

}
var staticRenderFns = []

export { render, staticRenderFns }